import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'swiper/css/pagination';


import Header from '../Component/Header';
import Footer from '../Component/Footer';

import Communityimpage from "../Components/Communityimpage";
import Comransform from "../Components/Comransform";
import Communitypage from "../Components/Communitypage";
import Communitylist from "../Components/Communitylist";
import Homeupcomingmeet from "../Components/Homeupcomingmeet";
import Communityupcomingmeet from "../Components/Communityupcomingmeet";
import MoCommunitylist from "../Components/MoCommunitylist";
import { API_BASE } from "../api/apiConfig";

const Community = () => {
     const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const images = [
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/sydney-event-718dPIskbatRbpERJbKB2VtOE6mx27.jpg',
      title: 'Tokyo Sakura Festival Meetup',
      participants: '45',
      location: 'Tokyo, Japan',
      date: 'April 2023',
      tags: ['Cultural', 'Photography', 'Seasonal'],
      quote: `"The local insights we gained were incredible. This wasn't just sightseeing—it was true cultural immersion."`,
      author: 'Emma W.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
    {
      src: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/barcelona-event-v8qNb2lZHt1WzNdU6KnSuuIg8g0ybm.jpg',
      title: 'NYC Rooftop Social',
      participants: '38',
      location: 'New York, USA',
      date: 'June 2023',
      tags: ['Urban', 'Networking', 'Evening'],
      quote: `"From strangers to friends in one evening. The views were amazing, but the connections were even better."`,
      author: 'Michael R.',
    },
  ];

  return (
    <>
      <Header />


<main class="min-h-screen overflow-hidden mobile-optimized">
    <div className='hidden md:block'>
        <section className="relative w-full overflow-hidden bg-[#0F172A] py-6 pb-0 sm:py-10 sm:pb-0 lg:py-16 lg:pb-0">
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-[#0F172A]" />
            </div>
            <div className="absolute inset-0 z-0 bg-[url('/subtle-pattern.png')] opacity-5" />
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-primary/0 via-primary to-primary/0" />
            <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
                <div className="flex flex-col justify-center space-y-6">
                    <div className="reveal-on-scroll revealed">
                    <div className="mb-4 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
                        <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary" />
                        Exclusive Travel Community
                    </div>
                    <h1 className="mb-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Join Our Indian{" "}
                        <span className="text-gradient">Travel Community</span>
                    </h1>
                    <p className="max-w-[600px] text-base text-slate-300 sm:text-lg">
                        Connect with passionate travelers, share experiences, and discover
                        hidden gems across India.
                    </p>
                    </div>
                    <div className="grid grid-cols-3 gap-4 rounded-xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm reveal-on-scroll revealed">
                    <div className="text-center">
                        <p className="text-xl font-bold text-primary sm:text-2xl">10K+</p>
                        <p className="text-sm text-slate-400">Members</p>
                    </div>
                    <div className="text-center">
                        <p className="text-xl font-bold text-primary sm:text-2xl">120+</p>
                        <p className="text-sm text-slate-400">Cities</p>
                    </div>
                    <div className="text-center">
                        <p className="text-xl font-bold text-primary sm:text-2xl">500+</p>
                        <p className="text-sm text-slate-400">Meetups</p>
                    </div>
                    </div>
                    <div className="flex flex-wrap gap-4 reveal-on-scroll revealed">
                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-primary text-[#0F172A] hover:bg-primary/90">
                        Join Our Community
                    </button>
                    <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-white/20 bg-white/5 text-white backdrop-blur-sm hover:bg-white/10">
                        Explore Meetups
                    </button>
                    </div>
                    <div className="flex items-center gap-4 reveal-on-scroll revealed">
                    <div className="flex -space-x-2">
                        <div
                        className="h-10 w-10 rounded-full border-2 border-[#0F172A] ring-1 ring-primary/20"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/community-gathering-UlZYUJCTevTyq0hH1sSVKq0LzbMlPR.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                        <div
                        className="h-10 w-10 rounded-full border-2 border-[#0F172A] ring-1 ring-primary/20"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                        <div
                        className="h-10 w-10 rounded-full border-2 border-[#0F172A] ring-1 ring-primary/20"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                        <div
                        className="h-10 w-10 rounded-full border-2 border-[#0F172A] ring-1 ring-primary/20"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                        <div
                        className="h-10 w-10 rounded-full border-2 border-[#0F172A] ring-1 ring-primary/20"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                    </div>
                    <div>
                        <p className="font-medium text-white">
                        Join <span className="text-primary">2,500+</span> travelers
                        </p>
                        <p className="text-sm text-slate-400">who joined this month</p>
                    </div>
                    </div>
                </div>
                <div className="relative reveal-on-scroll revealed">
                    <div className="overflow-hidden rounded-xl border border-white/20 bg-white/5 shadow-xl backdrop-blur-sm">
                    <div className="aspect-video w-full">
                        <div className="relative h-full w-full">
                        <img
                            alt="Travel community gathering"
                            decoding="async"
                            data-nimg="fill"
                            className="object-cover"
                            style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            color: "transparent"
                            }}
                            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/community-gathering-UlZYUJCTevTyq0hH1sSVKq0LzbMlPR.jpg"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/10" />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-14 w-14 rounded-full border-2 border-primary/50 bg-black/30 text-primary backdrop-blur-sm">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-play h-6 w-6"
                            >
                                <polygon points="6 3 20 12 6 21 6 3" />
                            </svg>
                            <span className="sr-only">Play community video</span>
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-lg border border-white/10 bg-black/50 px-4 py-2 backdrop-blur-md">
                        <p className="font-medium text-white">Our Community Story</p>
                        <p className="text-sm text-slate-300">2:45</p>
                    </div>
                    </div>
                    <div className="mt-4 rounded-lg border border-white/10 bg-white/5 p-4 backdrop-blur-md">
                    <div className="flex items-start gap-4">
                        <div
                        className="h-10 w-10 flex-shrink-0 rounded-full"
                        style={{
                            backgroundImage: 'url("https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg")',
                            backgroundSize: "cover"
                        }}
                        />
                        <div>
                        <p className="italic text-slate-300">
                            "This community changed how I travel across India. I've made
                            lifelong friends in multiple states."
                        </p>
                        <p className="mt-2 font-medium text-primary">
                            Priya S., Member since 2022
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div className="relative bg-white -mb-1 mt-12">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 120"
                className="w-full h-auto"
                >
                <path
                    fill="#fff"
                    fillOpacity={1}
                    d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
                />
                </svg>
            </div>
        </section>



    <section class="relative w-full bg-white pt-4 pb-12 md:pt-0 md:pb-16 text-slate-800 community-dtl-section">
        <div class="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl"></div>
        <div class="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl"></div>
        <div class="absolute inset-0 bg-[url('/diagonal-pattern.png')] opacity-5"></div>
        <div class="container relative z-10 mx-auto px-5 sm:px-6 md:px-6 -mt-2">
            <div class="mb-10 md:mb-10">
                {/* <!-- <div class="mb-7 md:mb-6 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
                    <div>
                        <h3 class="text-2xl md:text-2xl font-bold text-slate-800 flex items-center gap-2.5">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-camera h-6 w-6 md:h-6 md:w-6 text-primary"
                            >
                                <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                                <circle cx="12" cy="13" r="3"></circle>
                            </svg>
                            Community Meetups Around the World
                        </h3>
                        <p class="mt-2 text-base text-slate-700 leading-relaxed">Authentic experiences shared with fellow travelers who become friends</p>
                    </div>
                    <button
                        class="items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border hover:text-accent-foreground h-9 rounded-md px-3 mt-2 md:mt-0 text-sm border-primary/30 bg-transparent text-primary hover:bg-primary/10 hidden md:flex"
                    >
                        View All Meetups
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-chevron-right ml-1 h-3 w-3 md:h-4 md:w-4"
                        >
                            <path d="m9 18 6-6-6-6"></path>
                        </svg>
                    </button>
                </div> --> */}
                <div class="md:hidden space-y-8">
                    {/* <!-- <div class="relative">
                        <div class="swiper mainSwiper relative aspect-[4/3] w-full overflow-hidden rounded-xl shadow-md">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide relative">
                                    <img alt="Tokyo Sakura Festival Meetup" decoding="async" data-nimg="fill" class="object-cover" src="https://v0.blob.com/Nt9Ij.jpg" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
                                    <button class="absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Previous activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-left h-5 w-5"
                                        >
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                    <button class="absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Next activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-right h-5 w-5"
                                        >
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                    <div class="absolute bottom-0 left-0 right-0 p-5">
                                        <div class="flex flex-wrap items-center gap-2.5 mb-2">
                                            <div
                                                class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white text-sm px-2.5 py-1"
                                                data-v0-t="badge"
                                            >
                                                45 Participants
                                            </div>
                                            <div class="flex items-center gap-1.5 rounded-full bg-black/50 px-3 py-1 text-sm text-white backdrop-blur-sm">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="lucide lucide-map-pin h-3.5 w-3.5 text-primary"
                                                >
                                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                    <circle cx="12" cy="10" r="3"></circle>
                                                </svg>
                                                Tokyo, Japan
                                            </div>
                                        </div>
                                        <h4 class="text-xl font-semibold text-white leading-tight">Tokyo Sakura Festival Meetup</h4>
                                    </div>
                                </div>
                                <div class="swiper-slide relative">
                                    <img alt="Tokyo Sakura Festival Meetup" decoding="async" data-nimg="fill" class="object-cover" src="https://v0.blob.com/Nt9Ij.jpg" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
                                    <button class="absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Previous activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-left h-5 w-5"
                                        >
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                    <button class="absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Next activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-right h-5 w-5"
                                        >
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                    <div class="absolute bottom-0 left-0 right-0 p-5">
                                        <div class="flex flex-wrap items-center gap-2.5 mb-2">
                                            <div
                                                class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white text-sm px-2.5 py-1"
                                                data-v0-t="badge"
                                            >
                                                450 Participants
                                            </div>
                                            <div class="flex items-center gap-1.5 rounded-full bg-black/50 px-3 py-1 text-sm text-white backdrop-blur-sm">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="lucide lucide-map-pin h-3.5 w-3.5 text-primary"
                                                >
                                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                    <circle cx="12" cy="10" r="3"></circle>
                                                </svg>
                                                Tokyo, Japan
                                            </div>
                                        </div>
                                        <h4 class="text-xl font-semibold text-white leading-tight">Tokyo Sakura Festival Meetup</h4>
                                    </div>
                                </div>
                                <div class="swiper-slide relative">
                                    <img alt="Tokyo Sakura Festival Meetup" decoding="async" data-nimg="fill" class="object-cover"  src="https://v0.blob.com/Nt9Ij.jpg" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
                                    <button class="absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Previous activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-left h-5 w-5"
                                        >
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                    <button class="absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Next activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-right h-5 w-5"
                                        >
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                    <div class="absolute bottom-0 left-0 right-0 p-5">
                                        <div class="flex flex-wrap items-center gap-2.5 mb-2">
                                            <div
                                                class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white text-sm px-2.5 py-1"
                                                data-v0-t="badge"
                                            >
                                                50 Participants
                                            </div>
                                            <div class="flex items-center gap-1.5 rounded-full bg-black/50 px-3 py-1 text-sm text-white backdrop-blur-sm">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="lucide lucide-map-pin h-3.5 w-3.5 text-primary"
                                                >
                                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                    <circle cx="12" cy="10" r="3"></circle>
                                                </svg>
                                                Tokyo, Japan
                                            </div>
                                        </div>
                                        <h4 class="text-xl font-semibold text-white leading-tight">Tokyo Sakura Festival Meetup</h4>
                                    </div>
                                </div>
                                <div class="swiper-slide relative">
                                    <img alt="Tokyo Sakura Festival Meetup" decoding="async" data-nimg="fill" class="object-cover"  src="https://v0.blob.com/Nt9Ij.jpg" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
                                    <button class="absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Previous activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-left h-5 w-5"
                                        >
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                    <button class="absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Next activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-right h-5 w-5"
                                        >
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                    <div class="absolute bottom-0 left-0 right-0 p-5">
                                        <div class="flex flex-wrap items-center gap-2.5 mb-2">
                                            <div
                                                class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white text-sm px-2.5 py-1"
                                                data-v0-t="badge"
                                            >
                                                450 Participants
                                            </div>
                                            <div class="flex items-center gap-1.5 rounded-full bg-black/50 px-3 py-1 text-sm text-white backdrop-blur-sm">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="lucide lucide-map-pin h-3.5 w-3.5 text-primary"
                                                >
                                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                    <circle cx="12" cy="10" r="3"></circle>
                                                </svg>
                                                Tokyo, Japan
                                            </div>
                                        </div>
                                        <h4 class="text-xl font-semibold text-white leading-tight">Tokyo Sakura Festival Meetup</h4>
                                    </div>
                                </div>
                                <div class="swiper-slide relative">
                                    <img alt="Tokyo Sakura Festival Meetup" decoding="async" data-nimg="fill" class="object-cover"  src="https://v0.blob.com/Nt9Ij.jpg" />
                                    <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
                                    <button class="absolute left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Previous activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-left h-5 w-5"
                                        >
                                            <path d="m15 18-6-6 6-6"></path>
                                        </svg>
                                    </button>
                                    <button class="absolute right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-800 shadow-md" aria-label="Next activity">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-chevron-right h-5 w-5"
                                        >
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                    <div class="absolute bottom-0 left-0 right-0 p-5">
                                        <div class="flex flex-wrap items-center gap-2.5 mb-2">
                                            <div
                                                class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-primary text-white text-sm px-2.5 py-1"
                                                data-v0-t="badge"
                                            >
                                                50 Participants
                                            </div>
                                            <div class="flex items-center gap-1.5 rounded-full bg-black/50 px-3 py-1 text-sm text-white backdrop-blur-sm">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    class="lucide lucide-map-pin h-3.5 w-3.5 text-primary"
                                                >
                                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                    <circle cx="12" cy="10" r="3"></circle>
                                                </svg>
                                                Tokyo, Japan
                                            </div>
                                        </div>
                                        <h4 class="text-xl font-semibold text-white leading-tight">Tokyo Sakura Festival Meetup</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center justify-center gap-2.5 mt-5 mb-2">
                            <button class="h-2 rounded-full transition-all bg-primary w-8" aria-label="Go to activity 1"></button>
                            <button class="h-2 rounded-full transition-all bg-slate-300 w-2 hover:bg-slate-400" aria-label="Go to activity 2"></button>
                            <button class="h-2 rounded-full transition-all bg-slate-300 w-2 hover:bg-slate-400" aria-label="Go to activity 3"></button>
                            <button class="h-2 rounded-full transition-all bg-slate-300 w-2 hover:bg-slate-400" aria-label="Go to activity 4"></button>
                            <button class="h-2 rounded-full transition-all bg-slate-300 w-2 hover:bg-slate-400" aria-label="Go to activity 5"></button>
                        </div>
                    </div> --> */}
                    
                </div>
                

                <Communityupcomingmeet />

                
                <div className='md:hidden space-y-8'>
                    <div class="mt-6 text-center px-2"><button class="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border hover:text-accent-foreground h-11 rounded-md px-8 text-base font-medium border-primary/30 bg-transparent text-primary hover:bg-primary/10 w-full" __v0_r="0,11188,11284">View All Meetups<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right ml-1.5 h-5 w-5" __v0_r="0,11374,11390"><path d="m9 18 6-6-6-6"></path></svg></button></div>
                </div>
                <div class="mt-6 md:mt-10 md:block">
                    <h4 class="mb-3 md:mb-4 text-center text-base md:text-lg font-bold text-slate-800 flex items-center justify-center gap-1.5 md:gap-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-award md:h-5 md:w-5 text-amber-500"
                        >
                            <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                            <circle cx="12" cy="8" r="6"></circle>
                        </svg>
                        Community Achievements
                    </h4>
                    <div class="grid gap-2 md:gap-3 grid-cols-1 sm:grid-cols-3">
                        <div class="flex items-center gap-2 md:gap-3 rounded-lg border border-amber-200 bg-amber-50 p-2 md:p-3 transition-transform hover:scale-[1.02]">
                            <div class="flex md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-award h-6 w-6 text-amber-500"
                                >
                                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                    <circle cx="12" cy="8" r="6"></circle>
                                </svg>
                            </div>
                            <div>
                                <h5 class="text-xs md:text-sm font-bold text-slate-800">Community of the Year</h5>
                                <p class="text-[10px] md:text-xs text-slate-600">Global Travel Network • 2023</p>
                            </div>
                        </div>
                        <div class="flex items-center gap-2 md:gap-3 rounded-lg border border-amber-200 bg-amber-50 p-2 md:p-3 transition-transform hover:scale-[1.02]">
                            <div class="flex md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-award h-6 w-6 text-amber-500"
                                >
                                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                    <circle cx="12" cy="8" r="6"></circle>
                                </svg>
                            </div>
                            <div>
                                <h5 class="text-xs md:text-sm font-bold text-slate-800">Best Cultural Integration</h5>
                                <p class="text-[10px] md:text-xs text-slate-600">Sustainable Tourism Awards • 2023</p>
                            </div>
                        </div>
                        <div class="flex items-center gap-2 md:gap-3 rounded-lg border border-amber-200 bg-amber-50 p-2 md:p-3 transition-transform hover:scale-[1.02]">
                            <div class="flex md:h-10 md:w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-award h-6 w-6 text-amber-500"
                                >
                                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                    <circle cx="12" cy="8" r="6"></circle>
                                </svg>
                            </div>
                            <div>
                                <h5 class="text-xs md:text-sm font-bold text-slate-800">Top Travel Community</h5>
                                <p class="text-[10px] md:text-xs text-slate-600">Digital Nomad Association • 2022</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
 


        <section className="relative w-full overflow-hidden bg-slate-50 py-10 md:py-14 text-slate-800 testimonials-section">
        <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft" />
        <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft" />
        <div className="container mx-auto px-4 sm:px-5 md:px-6">
            <div className="mb-12 md:mb-16">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div className="max-w-3xl">
            <div className="mb-4 md:mb-6 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-4 py-2 text-sm md:text-base font-medium text-primary shadow-sm hover:shadow-md transition-all duration-300">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-sparkles mr-2 h-4 w-4 animate-pulse"
                >
                <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                <path d="M20 3v4" />
                <path d="M22 5h-4" />
                <path d="M4 17v2" />
                <path d="M5 18H3" />
                </svg>
                Pan-India Community, Local Connections
                <span className="ml-2 h-2 w-2 rounded-full bg-primary animate-pulse" />
            </div>
            <h2 className="mb-4 md:mb-6 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-800 leading-tight">
                Join Your Local Travel{" "}
                <span className="text-primary">Community ✨</span>
            </h2>
            <p className="max-w-2xl text-lg md:text-xl text-slate-600 leading-relaxed">
                From online conversations to real-life adventures, our city groups bring
                travelers together in meaningful ways, creating lasting friendships and
                unforgettable experiences across India.
            </p>
            </div>
            <div className="flex items-center gap-3 text-base md:text-lg font-medium">
            <span className="hidden text-primary md:inline">Explore all cities</span>
            <a href="/CommunityCity">
                <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-primary/30 bg-primary/5 text-primary hover:bg-primary/10 hover:scale-105 transition-all duration-300 shadow-sm hover:shadow-md">
                <span className="md:hidden">Explore all cities</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right h-5 w-5 ml-2"
                >
                    <path d="m9 18 6-6-6-6" />
                </svg>
                </button>
            </a>
            </div>
        </div>
        </div>

            
            <Communitylist />
            

            <div className="mt-2 flex items-center justify-center gap-1 md:hidden">
            <div className="h-1.5 w-8 rounded-full bg-primary/30 animate-pulse-soft" />
            <div
                className="h-1.5 w-4 rounded-full bg-primary/60 animate-pulse-soft"
                style={{ animationDelay: "0.2s" }}
            />
            <div
                className="h-1.5 w-3 rounded-full bg-primary/30 animate-pulse-soft"
                style={{ animationDelay: "0.4s" }}
            />
            </div>



            <div className="mt-20 md:mt-24">
                <div className="mb-12 md:mb-16 text-center">
                    <div className="mb-4 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-4 py-2 text-sm font-medium text-primary shadow-sm">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-award mr-2 h-4 w-4 animate-pulse"
                    >
                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                        <circle cx={12} cy={8} r={6} />
                    </svg>
                    Community Impact
                    </div>
                    <h3 className="mb-6 text-3xl md:text-4xl font-bold text-slate-800">
                    Transforming Travel <span className="text-primary">Experiences</span>
                    </h3>
                    <p className="mx-auto max-w-3xl text-lg md:text-xl text-slate-600 leading-relaxed">
                    Our community transforms how people experience India, creating meaningful
                    connections and unforgettable adventures across the country.
                    </p>
                </div>
            

                    <Comransform />            

                    
            
            </div>

            <div className="mt-10 md:mt-14">
            
                <div className="mt-16 md:mt-20 overflow-hidden rounded-2xl border-2 border-slate-200 bg-white shadow-xl transition-all duration-500 hover:shadow-2xl">
                    <div className="grid md:grid-cols-5">
                        <div className="relative hidden md:col-span-2 md:block">
                        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent z-10" />
                        <img
                            alt="Indian travel community gathering"
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="object-cover transition-transform duration-700 hover:scale-105"
                            style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            color: "transparent"
                            }}
                            src="/assets/images/community-gathering.png"
                        />
                        <div className="absolute bottom-6 left-6 z-20">
                            <div className="flex items-center gap-2 text-white">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-sparkles h-5 w-5 animate-pulse"
                            >
                                <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                                <path d="M5 3v4" />
                                <path d="M19 17v4" />
                                <path d="M3 5h4" />
                                <path d="M17 19h4" />
                            </svg>
                            <span className="text-sm font-medium">Real Community Stories</span>
                            </div>
                        </div>
                        </div>
                        <div className="p-8 md:col-span-3 md:p-10">
                        <div className="mb-6 flex items-center gap-4">
                            <div className="relative h-16 w-16 overflow-hidden rounded-full border-4 border-primary/20 shadow-lg">
                            <img
                                alt="Anjali S."
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover"
                                style={{
                                position: "absolute",
                                height: "100%",
                                width: "100%",
                                inset: 0,
                                color: "transparent"
                                }}
                                src="/assets/images/testimonial-avatar.png"
                            />
                            </div>
                            <div>
                            <p className="text-xl font-bold text-slate-800">Anjali S.</p>
                            <p className="text-primary font-medium">
                                Mumbai Group Member • 2 years
                            </p>
                            <div className="flex items-center gap-1 mt-1">
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                                >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                                >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                                >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                                >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400"
                                >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                            </div>
                            </div>
                        </div>
                        <div className="relative">
                            <div className="absolute -left-3 -top-3 text-6xl text-primary/20 font-serif">
                            "
                            </div>
                            <p className="mb-6 pl-8 text-lg italic text-slate-700 leading-relaxed">
                            I joined the online group first, then attended a local meetup in
                            Mumbai. Now I've traveled to 7 states with friends I met through the
                            community! What started as casual coffee meetups has turned into
                            lifelong friendships and adventures across India I never would have
                            experienced on my own.
                            </p>
                            <div className="absolute -bottom-3 right-0 text-6xl text-primary/20 font-serif">
                            "
                            </div>
                        </div>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <div
                            className="inline-flex items-center rounded-full border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20 transition-all duration-300 hover:scale-105 px-4 py-2 text-sm font-medium"
                            style={{ transitionDelay: "0ms" }}
                            >
                            Friendships
                            </div>
                            <div
                            className="inline-flex items-center rounded-full border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20 transition-all duration-300 hover:scale-105 px-4 py-2 text-sm font-medium"
                            style={{ transitionDelay: "100ms" }}
                            >
                            Group Travel
                            </div>
                            <div
                            className="inline-flex items-center rounded-full border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20 transition-all duration-300 hover:scale-105 px-4 py-2 text-sm font-medium"
                            style={{ transitionDelay: "200ms" }}
                            >
                            Cultural Exchange
                            </div>
                            <div
                            className="inline-flex items-center rounded-full border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-primary hover:bg-primary/20 transition-all duration-300 hover:scale-105 px-4 py-2 text-sm font-medium"
                            style={{ transitionDelay: "300ms" }}
                            >
                            Local Experiences
                            </div>
                        </div>
                        </div>
                    </div>
                </div>



            <div className="mt-6 md:mt-6 lg:mt-8 text-center">
                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 text-sm md:text-base bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105 btn-pulse px-5 py-2.5">
                Join Our Community
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-chevron-right ml-1.5 h-4 w-4 md:h-5 md:w-5 transition-transform duration-300 group-hover:translate-x-1"
                >
                    <path d="m9 18 6-6-6-6" />
                </svg>
                </button>
            </div>
            </div>
            {/* ./ */}




        </div>
        </section>
         

        <Homeupcomingmeet />
                

        <section class="relative w-full bg-slate-100 py-10 md:py-14 text-slate-800">
            <div class="absolute inset-0 bg-[url('/subtle-pattern.png')] opacity-5 animate-shimmer"></div>
            <div class="absolute right-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
            <div class="absolute bottom-0 left-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft" ></div>
            <div class="container relative z-10 mx-auto px-4 sm:px-5 md:px-6">
                <div class="mb-6 md:mb-8 text-center reveal-on-scroll revealed">
                    <div class="mb-2 md:mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-sm md:text-base font-medium text-primary hover-lift">
                        <span class="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>Exclusive Membership
                    </div>
                    <h2 class="mb-1.5 md:mb-2 text-xl md:text-2xl font-bold tracking-tight text-slate-800">Join Our Travel <span class="text-gradient">Community</span></h2>
                    <p class="mx-auto max-w-[700px] text-sm md:text-base text-slate-700">Become a member today and start connecting with fellow travelers around India.</p>
                </div>
                <div class="mx-auto max-w-4xl">
                    <div class="mb-6 grid gap-3 grid-cols-1 sm:grid-cols-3 reveal-on-scroll revealed">
                        <div class="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm transition-all duration-300 hover-lift hover:border-primary/30" >
                            <div class="mx-auto mb-2.5 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary animate-pulse-soft" >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-users h-5 w-5"
                                >
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>
                            <h4 class="mb-1 text-base md:text-lg font-medium text-slate-800 transition-colors duration-300 hover:text-primary">10,000+ Members</h4>
                            <p class="text-sm md:text-base text-slate-700">Join a thriving community of passionate Indian travelers.</p>
                        </div>
                        <div class="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm transition-all duration-300 hover-lift hover:border-primary/30" >
                            <div class="mx-auto mb-2.5 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary animate-pulse-soft" >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-calendar h-5 w-5"
                                >
                                    <path d="M8 2v4"></path>
                                    <path d="M16 2v4"></path>
                                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                                    <path d="M3 10h18"></path>
                                </svg>
                            </div>
                            <h4 class="mb-1 text-base md:text-lg font-medium text-slate-800 transition-colors duration-300 hover:text-primary">500+ Monthly Events</h4>
                            <p class="text-sm md:text-base text-slate-700">Access exclusive meetups, trips, and online gatherings.</p>
                        </div>
                        <div class="rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm transition-all duration-300 hover-lift hover:border-primary/30" >
                            <div class="mx-auto mb-2.5 flex h-10 w-10 items-center justify-center rounded-full bg-primary/20 text-primary animate-pulse-soft" >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-globe h-5 w-5"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                                    <path d="M2 12h20"></path>
                                </svg>
                            </div>
                            <h4 class="mb-1 text-base md:text-lg font-medium text-slate-800 transition-colors duration-300 hover:text-primary">120+ City Groups</h4>
                            <p class="text-sm md:text-base text-slate-700">Connect with travelers in your city and across India.</p>
                        </div>
                    </div>
                    <div class="text-card-foreground overflow-hidden rounded-xl border-2 border-primary/50 bg-white shadow-md hover-glow reveal-on-scroll revealed" data-v0-t="card">
                        <div class="flex flex-col space-y-1.5 relative border-b border-slate-200 bg-gradient-to-r from-primary/20 to-transparent p-4 pb-4 text-slate-800 md:p-5">
                            <div class="">
                                <div class="relative">
                                    <div class="animate-pulse rounded-full bg-primary/30 p-0 blur-xl"></div>
                                    <div
                                        class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap bg-primary px-2.5 py-1 text-sm md:text-base text-white animate-bounce-subtle"
                                        data-v0-t="badge"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-tag mr-1 h-3.5 w-3.5"
                                        >
                                            <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
                                            <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
                                        </svg>
                                        Early Bird Discount
                                    </div>
                                </div>
                            </div>
                            <div class="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-primary/10 blur-3xl animate-pulse-soft"></div>
                            
                            <div class="flex flex-col md:flex-row md:items-end md:justify-between">
                                <div>
                                    <h3 class="font-semibold tracking-tight text-xl md:text-2xl">Community Membership</h3>
                                    <p class="text-sm md:text-base text-slate-700">Full access to our Indian travel community</p>
                                </div>
                                <div class="mt-3 md:mt-0 flex items-end gap-3">
                                    <div class="flex flex-col items-end"><span class="text-xs md:text-sm text-slate-500">Regular Price</span><span class="text-base text-slate-500 line-through">₹499</span></div>
                                    <div class="flex flex-col items-end">
                                        <span class="text-xs md:text-sm text-primary">Limited Time</span>
                                        <div class="flex items-baseline"><span class="text-2xl md:text-3xl font-bold text-primary animate-pulse-soft">₹99</span><span class="ml-1 text-xs md:text-sm text-slate-500">only</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid gap-4 p-4 md:grid-cols-2 md:gap-5 md:p-5">
                            <div>
                                <div class="mb-2.5 text-sm md:text-base font-medium uppercase tracking-wider text-primary">Premium Access</div>
                                <div class="grid grid-cols-2 gap-2.5">
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">All city groups</span>
                                    </div>
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">Local meetups</span>
                                    </div>
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">Travel deals</span>
                                    </div>
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">Buddy matching</span>
                                    </div>
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">Community forums</span>
                                    </div>
                                    <div class="flex items-start gap-1.5 transition-all duration-300 hover:translate-x-1">
                                        <div class="mt-0.5 rounded-full bg-primary/20 p-0.5 text-primary animate-pulse-soft" >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="lucide lucide-check h-3.5 w-3.5"
                                            >
                                                <path d="M20 6 9 17l-5-5"></path>
                                            </svg>
                                        </div>
                                        <span class="text-sm text-slate-700 transition-colors duration-300 hover:text-slate-800">Priority access</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rounded-xl border border-slate-200 bg-slate-50 p-3 transition-all duration-300 hover:border-primary/20 hover:bg-primary/5">
                                <div class="mb-2.5 flex items-center gap-2">
                                    <div class="rounded-full bg-primary/20 p-1.5 text-primary animate-pulse-soft">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-mail h-4 w-4"
                                        >
                                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                        </svg>
                                    </div>
                                    <h4 class="text-base font-medium text-slate-800">Simple Joining Process</h4>
                                </div>
                                <div class="space-y-2.5">
                                    <div class="flex items-center gap-2 transition-all duration-300 hover:translate-x-1">
                                        <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary text-sm text-white animate-pulse-soft" >1</div>
                                        <p class="text-sm text-slate-700"><span class="font-medium text-slate-800">Pay ₹99</span> - Complete payment securely</p>
                                    </div>
                                    <div class="flex items-center gap-2 transition-all duration-300 hover:translate-x-1">
                                        <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary text-sm text-white animate-pulse-soft" >2</div>
                                        <p class="text-sm text-slate-700"><span class="font-medium text-slate-800">Check Email</span> - Get community link</p>
                                    </div>
                                    <div class="flex items-center gap-2 transition-all duration-300 hover:translate-x-1">
                                        <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary text-sm text-white animate-pulse-soft" >3</div>
                                        <p class="text-sm text-slate-700"><span class="font-medium text-slate-800">Join In</span> - Create profile &amp; join groups</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="items-center flex flex-col border-t border-slate-200 bg-slate-50 p-4 md:p-5">
                            <div class="mb-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-slate-700">
                                <div class="flex items-center gap-1.5 transition-all duration-300 hover:scale-110">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-shield h-4 w-4 text-primary"
                                    >
                                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                                    </svg>
                                    <span>One-time payment</span>
                                </div>
                                <div class="flex items-center gap-1.5 transition-all duration-300 hover:scale-110">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-award h-4 w-4 text-primary"
                                    >
                                        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
                                        <circle cx="12" cy="8" r="6"></circle>
                                    </svg>
                                    <span>Premium benefits</span>
                                </div>
                                <div class="flex items-center gap-1.5 transition-all duration-300 hover:scale-110">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-gift h-4 w-4 text-primary"
                                    >
                                        <rect x="3" y="8" width="18" height="4" rx="1"></rect>
                                        <path d="M12 8v13"></path>
                                        <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
                                        <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
                                    </svg>
                                    <span>Welcome package</span>
                                </div>
                            </div>
                            <button
                                class="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-11 rounded-md px-8 w-full text-base bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105 btn-pulse"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-credit-card mr-1.5 h-4 w-4"
                                >
                                    <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                    <line x1="2" x2="22" y1="10" y2="10"></line>
                                </svg>
                                Join Now for ₹99 Only
                            </button>
                            <p class="mt-2 flex items-center justify-center gap-1 text-xs md:text-sm text-slate-500">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-lock h-3.5 w-3.5 animate-pulse-soft"
                                >
                                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                                Secure payment with 256-bit encryption
                            </p>
                        </div>
                    </div>
                    <div class="mt-10 reveal-on-scroll revealed">
                        <h3 class="mb-4 text-center text-xl font-bold text-slate-800">Frequently Asked Questions</h3>
                        <div class="relative -mx-4 px-4 sm:-mx-5 sm:px-5 md:mx-0 md:px-0">
                            <div class="max-h-[450px] overflow-y-auto pr-3 space-y-2">

                                {/* <!-- Accordion Item --> */}
                                <details class="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group">
                                    <summary class="flex items-center justify-between cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300">
                                    Is this a one-time payment?
                                    <svg class="h-4 w-4 transition-transform duration-200 group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </summary>
                                    <div class="pb-4 text-sm text-slate-600">
                                    Yes, it is a one-time payment. No recurring charges will apply.
                                    </div>
                                </details>

                                {/* <!-- Accordion Item --> */}
                                <details class="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group">
                                    <summary class="flex items-center justify-between cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300">
                                    How quickly will I get access after payment?
                                    <svg class="h-4 w-4 transition-transform duration-200 group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </summary>
                                    <div class="pb-4 text-sm text-slate-600">
                                    You'll get access immediately after your payment is confirmed.
                                    </div>
                                </details>

                                {/* <!-- Accordion Item --> */}
                                <details class="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group">
                                    <summary class="flex items-center justify-between cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300">
                                    Are there any additional fees for events?
                                    <svg class="h-4 w-4 transition-transform duration-200 group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </summary>
                                    <div class="pb-4 text-sm text-slate-600">
                                    No, there are no additional fees unless stated otherwise for special events.
                                    </div>
                                </details>

                                {/* <!-- Accordion Item --> */}
                                <details class="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group">
                                    <summary class="flex items-center justify-between cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300">
                                    What if there's no group in my city?
                                    <svg class="h-4 w-4 transition-transform duration-200 group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </summary>
                                    <div class="pb-4 text-sm text-slate-600">
                                    You can join virtual sessions or start your own group with our help.
                                    </div>
                                </details>

                                {/* <!-- Accordion Item --> */}
                                <details class="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group">
                                    <summary class="flex items-center justify-between cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300">
                                    How long will the early bird discount be available?
                                    <svg class="h-4 w-4 transition-transform duration-200 group-open:rotate-180" fill="none" stroke="currentColor" stroke-width="2"
                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </summary>
                                    <div class="pb-4 text-sm text-slate-600">
                                    The early bird discount is available until [Insert Date or Condition].
                                    </div>
                                </details>
                                </div>

                                {/* <!-- Scroll Prompt for Mobile --> */}
                                <div class="mt-3 flex items-center justify-center gap-1 md:hidden">
                                <svg class="h-4 w-4 animate-bounce text-primary" fill="none" stroke="currentColor" stroke-width="2"
                                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="text-xs text-primary">Scroll for more</span>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section className="relative w-full bg-white py-16 text-slate-800 md:py-24">
        <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft" />
        <div
            className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"
            style={{ animationDelay: "1.5s" }}
        />
        <div className="absolute inset-0 bg-[url('/subtle-pattern.png')] opacity-5 animate-shimmer" />
        <div className="container mx-auto px-4 md:px-6">
            <div className="mb-10 text-center md:mb-16 reveal-on-scroll revealed">
            <div className="mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary hover-lift">
                <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft" />
                Community Voices
            </div>
            <h2 className="mb-3 text-2xl font-bold tracking-tight text-slate-800 sm:text-3xl md:text-4xl">
                What Our Members <span className="text-gradient">Say</span>
            </h2>
            <p className="mx-auto max-w-[700px] text-sm text-slate-600 md:text-base">
                Hear from travelers who have found connection, adventure, and friendship
                through our Indian travel community.
            </p>
            </div>
            <div className="relative -mx-4 px-4 reveal-on-scroll revealed">
            <button
                className="absolute -left-2 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-2 customPrevBtn"
                aria-label="Previous testimonial"
            >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left h-6 w-6"
                >
                <path d="m15 18-6-6 6-6" />
                </svg>
            </button>
            <div
                className="flex snap-x snap-mandatory gap-4 md:gap-6 overflow-x-auto pb-6 scrollbar-hide owl-carousel success-stories-owl"
                style={{ scrollbarWidth: "none" }}
            >
                <div
                className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-4 md:p-6 shadow-sm transition-all duration-500 hover-lift hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
                style={{ transitionDelay: "0ms" }}
                data-v0-t="card"
                >
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                    <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 hover-bright">
                        <img
                        alt="Priya Sharma"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 hover:scale-110"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            color: "transparent"
                        }}
                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg"
                        />
                    </div>
                    <div>
                        <h4 className="font-medium text-slate-800 transition-colors duration-300 hover:text-primary">
                        Priya Sharma
                        </h4>
                        <p className="text-xs text-slate-500">Mumbai, Maharashtra</p>
                    </div>
                    </div>
                    <div className="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "0ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "50ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "100ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "150ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "200ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    </div>
                </div>
                <div className="relative mb-4 rounded-lg bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5 hover:shadow-sm">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20 animate-pulse-soft"
                    >
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                    </svg>
                    <p className="pl-2 text-sm italic text-slate-600 transition-all duration-300 hover:text-slate-700">
                    "This community changed how I explore India. I've made lifelong
                    friends across 8 states and discovered hidden gems in my own
                    country I never knew existed."
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                    <span>Member since 2022</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>14 trips</span>
                    </div>
                    <div
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-xs font-normal text-primary transition-all duration-300 hover:bg-primary/20 hover:scale-105"
                    data-v0-t="badge"
                    >
                    Made 12 close friends through the community
                    </div>
                </div>
                </div>
                <div
                className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-4 md:p-6 shadow-sm transition-all duration-500 hover-lift hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
                style={{ transitionDelay: "100ms" }}
                data-v0-t="card"
                >
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                    <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 hover-bright">
                        <img
                        alt="Arjun Patel"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 hover:scale-110"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            color: "transparent"
                        }}
                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"
                        />
                    </div>
                    <div>
                        <h4 className="font-medium text-slate-800 transition-colors duration-300 hover:text-primary">
                        Arjun Patel
                        </h4>
                        <p className="text-xs text-slate-500">Delhi, NCR</p>
                    </div>
                    </div>
                    <div className="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "0ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "50ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "100ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "150ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "200ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    </div>
                </div>
                <div className="relative mb-4 rounded-lg bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5 hover:shadow-sm">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20 animate-pulse-soft"
                    >
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                    </svg>
                    <p className="pl-2 text-sm italic text-slate-600 transition-all duration-300 hover:text-slate-700">
                    "From solo traveler to part of a pan-India family. The local
                    meetups in Delhi are incredible, and I've traveled with community
                    members to Ladakh and Kerala."
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                    <span>Member since 2021</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>22 trips</span>
                    </div>
                    <div
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-xs font-normal text-primary transition-all duration-300 hover:bg-primary/20 hover:scale-105"
                    data-v0-t="badge"
                    >
                    Organized 5 community meetups in North India
                    </div>
                </div>
                </div>
                <div
                className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-4 md:p-6 shadow-sm transition-all duration-500 hover-lift hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
                style={{ transitionDelay: "200ms" }}
                data-v0-t="card"
                >
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                    <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 hover-bright">
                        <img
                        alt="Meera Iyer"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 hover:scale-110"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0
                        }}
                        src="https://v0.blob.com/Yd9Ij.png"
                        />
                    </div>
                    <div>
                        <h4 className="font-medium text-slate-800 transition-colors duration-300 hover:text-primary">
                        Meera Iyer
                        </h4>
                        <p className="text-xs text-slate-500">Bangalore, Karnataka</p>
                    </div>
                    </div>
                    <div className="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "0ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "50ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "100ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "150ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "200ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    </div>
                </div>
                <div className="relative mb-4 rounded-lg bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5 hover:shadow-sm">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20 animate-pulse-soft"
                    >
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                    </svg>
                    <p className="pl-2 text-sm italic text-slate-600 transition-all duration-300 hover:text-slate-700">
                    "I was hesitant to join at first, but it's been the best travel
                    decision I've made. The community is supportive, and I've
                    discovered so many weekend getaways from Bangalore."
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                    <span>Member since 2023</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>7 trips</span>
                    </div>
                    <div
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-xs font-normal text-primary transition-all duration-300 hover:bg-primary/20 hover:scale-105"
                    data-v0-t="badge"
                    >
                    Found travel companions for Northeast India tour
                    </div>
                </div>
                </div>
                <div
                className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-4 md:p-6 shadow-sm transition-all duration-500 hover-lift hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
                style={{ transitionDelay: "300ms" }}
                data-v0-t="card"
                >
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                    <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 hover-bright">
                        <img
                        alt="Vikram Singh"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 hover:scale-110"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0
                        }}
                        src="https://v0.blob.com/Yd9Ij.png"
                        />
                    </div>
                    <div>
                        <h4 className="font-medium text-slate-800 transition-colors duration-300 hover:text-primary">
                        Vikram Singh
                        </h4>
                        <p className="text-xs text-slate-500">Jaipur, Rajasthan</p>
                    </div>
                    </div>
                    <div className="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "0ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "50ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "100ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "150ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "200ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    </div>
                </div>
                <div className="relative mb-4 rounded-lg bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5 hover:shadow-sm">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20 animate-pulse-soft"
                    >
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                    </svg>
                    <p className="pl-2 text-sm italic text-slate-600 transition-all duration-300 hover:text-slate-700">
                    "As a local host in Jaipur, I've enjoyed showing travelers the
                    hidden gems of my city beyond the typical tourist spots. The
                    connections I've made have enriched my life."
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                    <span>Member since 2022</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>12 trips</span>
                    </div>
                    <div
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-xs font-normal text-primary transition-all duration-300 hover:bg-primary/20 hover:scale-105"
                    data-v0-t="badge"
                    >
                    Hosted 15+ travelers in Rajasthan
                    </div>
                </div>
                </div>
                <div
                className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-4 md:p-6 shadow-sm transition-all duration-500 hover-lift hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
                style={{ transitionDelay: "400ms" }}
                data-v0-t="card"
                >
                <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                    <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20 hover-bright">
                        <img
                        alt="Ananya Desai"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-500 hover:scale-110"
                        style={{
                            position: "absolute",
                            height: "100%",
                            width: "100%",
                            inset: 0,
                            color: "transparent"
                        }}
                        src="https://v0.blob.com/Yd9Ij.png"
                        />
                    </div>
                    <div>
                        <h4 className="font-medium text-slate-800 transition-colors duration-300 hover:text-primary">
                        Ananya Desai
                        </h4>
                        <p className="text-xs text-slate-500">Ahmedabad, Gujarat</p>
                    </div>
                    </div>
                    <div className="flex items-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "0ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "50ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "100ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "150ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-star h-4 w-4 fill-primary text-primary transition-transform duration-300 hover:scale-125"
                        style={{ transitionDelay: "200ms" }}
                    >
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    </div>
                </div>
                <div className="relative mb-4 rounded-lg bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5 hover:shadow-sm">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20 animate-pulse-soft"
                    >
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                    </svg>
                    <p className="pl-2 text-sm italic text-slate-600 transition-all duration-300 hover:text-slate-700">
                    "The community helped me gain confidence as a solo female traveler
                    in India. Now I explore with new friends and share my experiences
                    with other women in the group."
                    </p>
                </div>
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                    <span>Member since 2021</span>
                    <span className="h-1 w-1 rounded-full bg-slate-300" />
                    <span>18 trips</span>
                    </div>
                    <div
                    className="inline-flex items-center rounded-full border px-2.5 py-0.5 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary/10 text-xs font-normal text-primary transition-all duration-300 hover:bg-primary/20 hover:scale-105"
                    data-v0-t="badge"
                    >
                    Started a women's travel safety subgroup
                    </div>
                </div>
                </div>
            </div>
            <button
                className="absolute -right-2 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-2 customNextBtn"
                aria-label="Next testimonial"
            >
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-right h-6 w-6"
                >
                <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
            </div>
            <div className="mt-10 md:mt-12 rounded-xl border border-slate-200 bg-gradient-to-r from-primary/10 to-white p-6 md:p-8 shadow-sm hover-glow reveal-on-scroll revealed">
            <div className="mx-auto max-w-3xl text-center">
                <h3 className="mb-4 text-xl font-bold text-slate-800 md:text-2xl">
                Ready to Join India's Largest Travel{" "}
                <span className="text-gradient">Community</span>?
                </h3>
                <p className="mb-6 text-slate-600">
                Connect with passionate travelers from across India, share
                experiences, and create memories that last a lifetime.
                </p>
                <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-11 rounded-md px-8 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105 btn-pulse">
                Join Our Community Today
                </button>
                <p className="mt-4 text-xs text-slate-500">
                Join now and get access to exclusive travel resources, local meetups,
                and a nationwide network of friends.
                </p>
            </div>
            </div>
        </div>
        </section>
    
    </div>





    <div className="md:hidden pb-10 mb-10 scrollbar-custom">
        <div className="relative h-44 bg-gradient-to-r from-teal-500 to-cyan-500 flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 bg-[url('/travel-pattern-bg.png')] opacity-10" />
            <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl font-bold text-white mb-1">
                Join Your <span className="text-yellow-300">Community</span>
            </h1>
            <p className="text-sm text-white/90">
                Connect with travelers in your city
            </p>
            </div>
        </div>
        <div className="bg-white px-4 py-8 border-b border-slate-100">
            <h2 className="text-lg font-bold text-slate-900 mb-4">
            Why Join Community?
            </h2>
            <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 bg-teal-50 rounded-lg">
                <div className="h-10 w-10 rounded-full bg-teal-500 flex items-center justify-center flex-shrink-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users h-5 w-5 text-white"
                >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx={9} cy={7} r={4} />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                </div>
                <div>
                <h3 className="font-semibold text-sm text-slate-900 mb-1">
                    Find Travel Buddies
                </h3>
                <p className="text-xs text-slate-600">
                    Meet like-minded travelers from your city who share your passion for
                    exploration
                </p>
                </div>
            </div>
            <div className="flex items-start gap-3 p-3 bg-cyan-50 rounded-lg">
                <div className="h-10 w-10 rounded-full bg-cyan-500 flex items-center justify-center flex-shrink-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-calendar h-5 w-5 text-white"
                >
                    <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                    <line x1={16} x2={16} y1={2} y2={6} />
                    <line x1={8} x2={8} y1={2} y2={6} />
                    <line x1={3} x2={21} y1={10} y2={10} />
                </svg>
                </div>
                <div>
                <h3 className="font-semibold text-sm text-slate-900 mb-1">
                    Join Local Meetups
                </h3>
                <p className="text-xs text-slate-600">
                    Attend pre-trip meetups and get to know your travel companions
                    before the journey
                </p>
                </div>
            </div>
            <div className="flex items-start gap-3 p-3 bg-purple-50 rounded-lg">
                <div className="h-10 w-10 rounded-full bg-purple-500 flex items-center justify-center flex-shrink-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle h-5 w-5 text-white"
                >
                    <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                </svg>
                </div>
                <div>
                <h3 className="font-semibold text-sm text-slate-900 mb-1">
                    Share Experiences
                </h3>
                <p className="text-xs text-slate-600">
                    Exchange travel stories, tips, and recommendations with the
                    community
                </p>
                </div>
            </div>
            </div>
        </div>
        <div className="bg-white px-4 py-8 border-b border-slate-100">
            <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-slate-900">Community Moments</h2>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-camera h-5 w-5 text-teal-500"
            >
                <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
                <circle cx={12} cy={13} r={3} />
            </svg>
            </div>
            <div className="grid grid-cols-3 gap-2 mb-4">
            <div className="aspect-square rounded-lg overflow-hidden">
                <img
                alt="Community meetup"
                className="w-full h-full object-cover"
                src="/assets/images/group-of-friends-meeting-at-cafe-for-travel-planni.jpg"
                />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden">
                <img
                alt="Group travel"
                className="w-full h-full object-cover"
                src="/assets/images/group-of-happy-travelers.jpg"
                />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden">
                <img
                alt="Travel adventure"
                className="w-full h-full object-cover"
                src="/assets/images/solo-mountain-vista.png"
                />
            </div>
            </div>
            <p className="text-xs text-slate-600 text-center">
            Join our community and create unforgettable memories together
            </p>
        </div>
        

        <MoCommunitylist />


    </div>



</main>


      <Footer />
    </>
  );
};

export default Community;
